import store from '@/store'

export default function getAddOnsList(bookingKey) {
  return new Promise((resolve, reject) => {
    store
      .dispatch('addOns/apiCall', {
        mode: 'Select',
        request: {
          all: process.env.VUE_APP_API_ALL,
          srt: 'createdOn',
          desc: false,
          bookingKey,
        },
      })
      .then(response => {
        if (response.success) {
          resolve(response.data.items)
        } else {
          reject(response.error)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}
